// Zufällige, nicht-sensitive Terminal-/Client-Instanz-ID je Browserprofil.
// Kein Hardware-Fingerprint, keine MAC, kein User-PII. Einmal erzeugt,
// lokal persistent, bei erneutem Öffnen wiederverwendet.
const KEY = "shoppipoint.terminal_id";

export function getOrCreateTerminalId(storage: Storage = localStorage): string {
  let id = "";
  try {
    id = storage.getItem(KEY) ?? "";
  } catch {
    id = "";
  }
  if (!isUuid(id)) {
    id = crypto.randomUUID();
    try {
      storage.setItem(KEY, id);
    } catch {
      // Storage nicht verfügbar (z. B. Private Mode) -> ID nur für diese Session.
    }
  }
  return id;
}

function isUuid(v: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v);
}
